"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDocs = void 0;
var formatDocs = {
  name: 'format',
  category: 'Utils',
  syntax: ['format(value)', 'format(value, precision)'],
  description: 'Format a value of any type as string.',
  examples: ['format(2.3)', 'format(3 - 4i)', 'format([])', 'format(pi, 3)'],
  seealso: ['print']
};
exports.formatDocs = formatDocs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/expression/embeddedDocs/function/utils/format.js
// module id = kH4f
// module chunks = 23